import React from 'react';
import './App.css';
import Navbar from './components/Navbar'
import Home from './pages/Home'
import Spells from './pages/Spells'
import FavSpells from './pages/FavSpells'
import { Provider } from 'react-redux'
import store from './store/storeIndex'

import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom'

class App extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      showPerson : false,
    }
  }

  render(){
    return (
      <Provider store={store}>
        <Router>
          <div>
            <Navbar/>
            <Switch>

              <Route exact path='/spells'>
                <Spells/>
              </Route>
              
              <Route exact path='/spells/fav'>
                <FavSpells/>
              </Route>
              
              <Route path='/'>
                <Home/>
              </Route>


            </Switch>
          </div>
        </Router>
      </Provider>
    )
  }
}



export default App;
